<template>
	<button
		type="button"
		class="relative"
		:class="{ disabled: disabled }"
		:disabled="(disabled && !disabledEmit) || loading"
		@click="handleClick()"
	>
		<div class="lds-ring" v-if="loading && !disabled">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
		<span v-else>{{ text }}</span>
	</button>
</template>

<script>
export default {
	props: {
		text: { type: String, default: null },
		loading: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		disabledEmit: { type: Boolean, default: true },
	},
	methods: {
		handleClick(e) {
			if (!this.disabled || this.disabledEmit) {
				this.$emit('click', e);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.lds-ring {
	display: inline-block;
	position: absolute;
	width: 24px;
	height: 24px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 24px;
	height: 24px;
	border: 2px solid #fff;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}

@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
